import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { ManikEntityFE, CookieManager } from '../../manik-library/ManikEntityFE';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ManikEntityService } from '../../manik-library/ManikEntityService';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-visitor-handler',
  templateUrl: './visitor-handler.component.html',
  styleUrls: ['./visitor-handler.component.scss']
})
export class VisitorHandlerComponent extends ManikEntityFE implements OnInit {
  submitted = false;
  VisitorPhoneForm: FormGroup;
  VisitorDetailsForm: FormGroup;
  OTPForm: FormGroup;
  SessionData: any;
  IsInitialised: boolean = false;
  maxlength: any;
  CountryList: any;
  ShowForm: boolean = false;
  ShowLoader: boolean = false;
  ShowVerifyOTP: boolean = false;
  EmailError = '*required';
  PassError = '*required';
  showPassError=false;
  AskEmail: boolean = false;
  VisitorData: any = {};
  OTPHandle: string = '';
  showEmailError=false;
  enPass=""
  @Input() CountryID = 100023;
  @Input() PortalID = 100002;
  @Input() PortalName: string;
  @Output() visitorLoggedIn = new EventEmitter();
  needOTPCheck:boolean=false;
  populateControls(): void {
    throw new Error("Method not implemented.");
  }
  refreshDataGrid(param: any): void {
    throw new Error("Method not implemented.");
  }

  constructor(private formBuilder: FormBuilder, public _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any) {
    super(document);
    this.VisitorPhoneForm = this.formBuilder.group({
      Country: [''],
      CountryCode: [''],
      CountryAC: [''],
      CountryID: [''],
      MobileNumber: ['', Validators.required]
    });
    this.VisitorDetailsForm = this.formBuilder.group({
      VisitorName: ['', Validators.required],
      EmailID: ['', [Validators.required ,  Validators.email]],
      // Password: ['', Validators.required],
      OKToContactBack: ['', Validators.required]
    });
    this.OTPForm = this.formBuilder.group({
      OTP: ['', Validators.required],
      CouponHandle: ['']
    });
  }

  ngOnInit() {
    this.IsInitialised = false;
    this.SessionData = JSON.parse(sessionStorage.getItem("SiteMetaData"));
    this.updateFilterParams('');
    this._manikEntityService.manikAutoComplete2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("SEMI.QUICK", "GET.COUNTRY", "MANIK.GLOBAL", this.SessionData.PC))
      .subscribe(data => {
        let resp: any = data;
        this.CountryList = resp.ManikJSon[0].JSon0;
        let country = resp.ManikJSon[0].JSon0.find(item => item.DataValue == this.CountryID);
        this.VisitorPhoneForm.controls['CountryAC'].setValue(country);
        this.VisitorPhoneForm.controls['CountryCode'].setValue(country.CountryCode);
        this.VisitorPhoneForm.controls['Country'].setValue(country.DataText);
        this.VisitorPhoneForm.controls['CountryID'].setValue(country.DataValue);
        this.maxlength = country.MobileNumberLength;
        this.VisitorPhoneForm.controls['MobileNumber'].setValidators([Validators.required, Validators.maxLength(this.maxlength), Validators.minLength(this.maxlength)]);
        this.VisitorPhoneForm.controls['MobileNumber'].updateValueAndValidity();
        this.IsInitialised = true;
      });
  }


  GetCountryList() {
    this.updateFilterParams(this.VisitorPhoneForm.value.CountryAC);
    return this._manikEntityService.manikAutoComplete2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("SEMI.QUICK", "GET.COUNTRY", "MANIK.GLOBAL",
        this.SessionData.ReservedIdentifier)).subscribe(
          data => {
            let resp: any = data;
            this.CountryList = resp.ManikJSon[0].JSon0;
          });
  }

  OnSelectCountry(event: any) {

    console.log(this.CountryList,event.target.value)
    let x;
    this.CountryList.forEach(item => {
      if(item.DataValue.toString() == event.target.value){
        x=item
      }
    });
    // (item => { return (item.DataValue.toString() == event.target.value?x=item:x=[]) });
    console.log(x)
    this.VisitorPhoneForm.controls['CountryCode'].setValue(x.CountryCode);
    this.VisitorPhoneForm.controls['Country'].setValue(x.DataText);
    this.VisitorPhoneForm.controls['CountryID'].setValue(x.DataValue);
    this.maxlength = x.MobileNumberLength;
    this.VisitorPhoneForm.controls['MobileNumber'].setValidators([Validators.required, Validators.maxLength(this.maxlength), Validators.minLength(this.maxlength)]);
        this.VisitorPhoneForm.controls['MobileNumber'].updateValueAndValidity();
    console.log(this.CountryList)
  }


  CheckIfContactExists() {
    this.PortalID=100003
    this.ShowForm = false;
    if (this.VisitorPhoneForm.controls['MobileNumber'].errors) {
      return;
    }
    this.ShowLoader = true;
    this.updateFilterParams(this.PortalID, this.VisitorPhoneForm.controls['CountryCode'].value, this.VisitorPhoneForm.controls['MobileNumber'].value);//this.SessionData.PortalID
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("FETCH.BY.MOBILE", "VISITOR", "MANIK.GLOBAL",
        this.SessionData.PC)).subscribe(
          data2 => {
            sessionStorage.setItem("ShowButton",'false')
         
            CookieManager.setCookie('ShowButton', 'false', 1, '/');
            let resp = data2.ManikJSon[0].JSon0[0];
            if (resp.VisitorHandle != "DOES_NOT_EXIST") {
              this.AskEmail = true;
              this.ShowForm = true;
              this.ShowLoader = false;
              this.enPass=resp.enP
              this.VisitorDetailsForm.controls["VisitorName"].setValue(resp.VisitorName);
              this.VisitorDetailsForm.controls["VisitorName"].disable();
              this.VisitorDetailsForm.controls["EmailID"].setValue(resp.EmailID);
              this.VisitorDetailsForm.controls["EmailID"].disable();
              this.VisitorData = data2.ManikJSon[0].JSon0[0];
              this.enPass='E'
              // this.OTPHandle = data2.ManikJSon[0].JSon1[0].OTPHandle;
              // this.ShowVerifyOTP = true;
            }
            if (resp.VisitorHandle == "DOES_NOT_EXIST" ) {
              this.AskEmail = true;
              this.ShowForm = true;
              this.ShowLoader = false;
              this.VisitorDetailsForm.controls["VisitorName"].setValue("");
              this.VisitorDetailsForm.controls["EmailID"].setValue("");
              this.VisitorDetailsForm.controls["VisitorName"].enable();
              this.VisitorDetailsForm.controls["EmailID"].enable();
              this.VisitorDetailsForm.controls["EmailID"].setValidators([Validators.required, Validators.email,
              Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$")])
              // this.OTPHandle = data2.ManikJSon[0].JSon1[0].OTPHandle;
              // this.ShowVerifyOTP = true;
              this.enPass=''
            }
          });
  }


  convertDateString(date: any) {
    let dates = this.getManikDateString(date);
    let myDate = new Date(dates);
    let d = myDate.getDate();
    let m = myDate.getMonth();
    m += 1;
    var y = myDate.getFullYear();
    date = (y + "-" + m + "-" + d);
    return date;
  }


  SubmitForm() {
    this.PortalID= 100003
    
    if (this.VisitorDetailsForm.invalid) {
      this.submitted = false;
      return;
    }
    this.submitted = true;
    if (this.AskEmail) {
      let body: any = {};
      body['PortalID'] = this.PortalID;
      body['VisitorName'] = this.VisitorDetailsForm.controls.VisitorName.value;
      body['EmailID'] = this.VisitorDetailsForm.controls.EmailID.value;
      body['CountryCode'] = this.VisitorPhoneForm.controls.CountryCode.value;
      body['MobileNumber'] = this.VisitorPhoneForm.controls.MobileNumber.value;
      body['OKToContactBack'] = this.VisitorDetailsForm.controls.OKToContactBack.value == true ? 'Y': 'N';
      // this._manikEntityService.manikEntityConnect2("WebSite/encript?data=" +
      //  this.VisitorDetailsForm.controls.Password.value, null, null)
      //   .subscribe(data => {
          let operation
          // body['EncryptedPassword'] = data.EncryptedData;
          // console.log(this.enPass)
          // if(this.enPass){
          //   if(this.enPass==data.EncryptedData ){
          //     this.PassError='';
          //     operation="E";
          //     this.showPassError=false;
          //   }
          //   else{
          //    this.showPassError=true;
          //    this.PassError="Wrong Password"
          //    this.submitted=false;
          //    return
          //   }
          // }
      
          if(!this.enPass){
            operation="A"
          }
          else{
            operation="E"
          }
         
          let FrmSubmittedData = JSON.stringify({ 'items': [body] });
          this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", FrmSubmittedData, 
          this.prepareManageHeaders2(operation, "VISITOR", "MANIK.GLOBAL", this.SessionData.PC))
            .subscribe(data => {
              if (data.ManikJSon[0].JSon0[0].NewEntity == 'EMAIL_ALREADY_TAKEN'  || data.ManikJSon[0].JSon0[0].NewEntity =='ALREADY_EXISTS') {
               this.showEmailError=true;
                              
                  this.EmailError = 'Email ID already in use';
                  this.VisitorDetailsForm.controls['EmailID'].reset();
                  this.VisitorDetailsForm.controls["VisitorName"].enable();
                  this.VisitorDetailsForm.controls["EmailID"].enable();
                // this.submitted=false;
              }
              else {
                this.VisitorData = data.ManikJSon[0].JSon0[0];
                // this.OTPHandle = data.ManikJSon[0].JSon1[0].OTPHandle;
                // this.ShowVerifyOTP = true;
                this.submitted=false;
                this.showEmailError=false;
                //
                this.ShowVerifyOTP=false;
                this.ShowForm = false;
                this.IsInitialised = false;
                sessionStorage.setItem("ShowButton",'true');
                CookieManager.setCookie('ShowButton', 'true', 1, '/');
            console.log(sessionStorage.getItem("ShowButton"))
                //
              }
              this.submitted = false;

            });
        // });
    }
  }

  OTPVerified() {
    CookieManager.setCookie('VisitorData', JSON.stringify(this.VisitorData), 1, '/');
    this.visitorLoggedIn.emit('Y');
  }
  get dForm() {
    return this.VisitorDetailsForm.controls;
  }
}
